<div class="center-align">
  <mat-card class="status-card">
    <mat-card-content>
      <div class="status-section topic-section {{(context())}}">
        <span>{{ topic() }}</span>
      </div>
      <div class="status-section content-section {{context()}}" matTooltip="{{messageToolTip()}}">
        <span>{{ message() }}</span>
        @if (additionalMessageIndicator()) {
          <mat-icon
          [class.clickable]="iconClickable() && iconClick"
          (click)="iconClickable() && iconClick.emit($event)"
          matTooltip="Additional rules associated with this status.">
          {{ additionalMessageIndicator() }}
          </mat-icon>
        }
      </div>
    </mat-card-content>
  </mat-card>
</div>
